// extracted by mini-css-extract-plugin
export default {"label":"styles_label__cQ5P4","checkbox_container":"styles_checkbox_container__qlBIu","checkbox":"styles_checkbox__63nTG","icon":"styles_icon__Ih8t3"};